import createPlotlyComponent from "react-plotlyjs";
import React, { PureComponent } from "react";
import Plotly from "plotly.js/dist/plotly";
import moment from "moment";
import _ from "lodash";

import styled from "styled-components";

export const Wrapper = styled.div`
  &&& {
    .js-plotly-plot {
      padding-bottom: 70px;
    }
    .svg-container {
      margin: auto;
    }
    .main-svg {
      overflow: visible;
    }
    rect {
      cursor: default !important;
    }
  }
`;

const PlotlyComponent = createPlotlyComponent(Plotly);

export default class PlotlyBoxAndWhisker extends PureComponent {
  render() {
    const dataGroups = [];
    const template = {
      type: "box",
      jitter: 1,
      pointpos: -2,
      whiskerwidth: 0.4,
      marker: {
        color: "rgb(7,40,89)",
        size: 4,
      },
      boxpoints: "all",
      line: {
        width: 2,
      },
    };
    const months = [];
    let date = moment(this.props.start);
    date.date(1);
    while (date < moment(this.props.end)) {
      const start = moment(date);
      date.month(date.month() + 1);
      const end = moment(date);
      months.push({ start, end });
    }

    const ratingFilter = this.props.ratings.length > 0;

    if (this.props.domains.length < 1 || _.includes(this.props.domains, "Briefing")) {
      const name = "Briefing";
      const color = "rgb(7, 40, 89)";
      if (this.props.grouping === "MONTHLY") {
        _.forEach(months, month => {
          const dataGroup = _.cloneDeep(template);
          dataGroup.y = _.filter(this.props.observations, observation => {
            const date = moment(observation.obsDate);
            return date >= month.start && date < month.end && observation.briefRate;
          }).map(observation => observation.briefRate);
          dataGroup.y = _.filter(dataGroup.y, rating => {
            return !ratingFilter || _.includes(this.props.ratings, rating);
          });
          if (dataGroup.y.length < 1) {
            dataGroup.y = [0];
          }
          dataGroup.name = `${name} - ${month.start.format("MMMM YYYY")}`;
          dataGroup.marker.color = color;
          dataGroups.push(dataGroup);
        });
      } else {
        const dataGroup = _.cloneDeep(template);
        dataGroup.y = this.props.observations.map(observation => observation.briefRate);
        dataGroup.y = _.filter(dataGroup.y, rating => {
          return !ratingFilter || _.includes(this.props.ratings, rating);
        });
        dataGroup.name = name;
        dataGroup.marker.color = color;
        dataGroups.push(dataGroup);
      }
    }

    if (this.props.domains.length < 1 || _.includes(this.props.domains, "Inquiry & Rebriefing")) {
      const name = "Inquiry & Rebriefing";
      const color = "rgb(107, 174, 214)";
      if (this.props.grouping === "MONTHLY") {
        _.forEach(months, month => {
          const dataGroup = _.cloneDeep(template);
          dataGroup.y = _.filter(this.props.observations, observation => {
            const date = moment(observation.obsDate);
            return date >= month.start && date < month.end && observation.inqRate;
          }).map(observation => observation.inqRate);
          dataGroup.y = _.filter(dataGroup.y, rating => {
            return !ratingFilter || _.includes(this.props.ratings, rating);
          });
          if (dataGroup.y.length < 1) {
            dataGroup.y = [0];
          }
          dataGroup.name = `${name} - ${month.start.format("MMMM YYYY")}`;
          dataGroup.marker.color = color;
          dataGroups.push(dataGroup);
        });
      } else {
        const dataGroup = _.cloneDeep(template);
        dataGroup.y = this.props.observations.map(observation => observation.inqRate);
        dataGroup.y = _.filter(dataGroup.y, rating => {
          return !ratingFilter || _.includes(this.props.ratings, rating);
        });
        dataGroup.name = name;
        dataGroup.marker.color = color;
        dataGroups.push(dataGroup);
      }
    }

    if (this.props.domains.length < 1 || _.includes(this.props.domains, "Assertion & Challenge")) {
      const name = "Assertion & Challenge";
      const color = "rgb(0, 128, 128)";
      if (this.props.grouping === "MONTHLY") {
        _.forEach(months, month => {
          const dataGroup = _.cloneDeep(template);
          dataGroup.y = _.filter(this.props.observations, observation => {
            const date = moment(observation.obsDate);
            return date >= month.start && date < month.end && observation.assertRate;
          }).map(observation => observation.assertRate);
          dataGroup.y = _.filter(dataGroup.y, rating => {
            return !ratingFilter || _.includes(this.props.ratings, rating);
          });
          if (dataGroup.y.length < 1) {
            dataGroup.y = [0];
          }
          dataGroup.name = `${name} - ${month.start.format("MMMM YYYY")}`;
          dataGroup.marker.color = color;
          dataGroups.push(dataGroup);
        });
      } else {
        const dataGroup = _.cloneDeep(template);
        dataGroup.y = this.props.observations.map(observation => observation.assertRate);
        dataGroup.y = _.filter(dataGroup.y, rating => {
          return !ratingFilter || _.includes(this.props.ratings, rating);
        });
        dataGroup.name = name;
        dataGroup.marker.color = color;
        dataGroups.push(dataGroup);
      }
    }

    if (this.props.domains.length < 1 || _.includes(this.props.domains, "Structured Communication")) {
      const name = "Structured Communication";
      const color = "rgba(127, 96, 0, 0.5)";
      if (this.props.grouping === "MONTHLY") {
        _.forEach(months, month => {
          const dataGroup = _.cloneDeep(template);
          dataGroup.y = _.filter(this.props.observations, observation => {
            const date = moment(observation.obsDate);
            return date >= month.start && date < month.end && observation.struccomRate;
          }).map(observation => observation.struccomRate);
          dataGroup.y = _.filter(dataGroup.y, rating => {
            return !ratingFilter || _.includes(this.props.ratings, rating);
          });
          if (dataGroup.y.length < 1) {
            dataGroup.y = [0];
          }
          dataGroup.name = `${name} - ${month.start.format("MMMM YYYY")}`;
          dataGroup.marker.color = color;
          dataGroups.push(dataGroup);
        });
      } else {
        const dataGroup = _.cloneDeep(template);
        dataGroup.y = this.props.observations.map(observation => observation.struccomRate);
        dataGroup.y = _.filter(dataGroup.y, rating => {
          return !ratingFilter || _.includes(this.props.ratings, rating);
        });
        dataGroup.name = name;
        dataGroup.marker.color = color;
        dataGroups.push(dataGroup);
      }
    }

    if (this.props.domains.length < 1 || _.includes(this.props.domains, "Closing the Loop")) {
      const name = "Closing the Loop";
      const color = "rgba(79, 90, 117, 0.5)";
      if (this.props.grouping === "MONTHLY") {
        _.forEach(months, month => {
          const dataGroup = _.cloneDeep(template);
          dataGroup.y = _.filter(this.props.observations, observation => {
            const date = moment(observation.obsDate);
            return date >= month.start && date < month.end && observation.loopRate;
          }).map(observation => observation.loopRate);
          dataGroup.y = _.filter(dataGroup.y, rating => {
            return !ratingFilter || _.includes(this.props.ratings, rating);
          });
          if (dataGroup.y.length < 1) {
            dataGroup.y = [0];
          }
          dataGroup.name = `${name} - ${month.start.format("MMMM YYYY")}`;
          dataGroup.marker.color = color;
          dataGroups.push(dataGroup);
        });
      } else {
        const dataGroup = _.cloneDeep(template);
        dataGroup.y = this.props.observations.map(observation => observation.loopRate);
        dataGroup.y = _.filter(dataGroup.y, rating => {
          return !ratingFilter || _.includes(this.props.ratings, rating);
        });
        dataGroup.name = name;
        dataGroup.marker.color = color;
        dataGroups.push(dataGroup);
      }
    }

    if (this.props.domains.length < 1 || _.includes(this.props.domains, "Debriefing")) {
      const name = "Debriefing";
      const color = "rgba(255, 65, 54, 0.5)";
      if (this.props.grouping === "MONTHLY") {
        _.forEach(months, month => {
          const dataGroup = _.cloneDeep(template);
          dataGroup.y = _.filter(this.props.observations, observation => {
            const date = moment(observation.obsDate);
            return date >= month.start && date < month.end && observation.debriefRate;
          }).map(observation => observation.debriefRate);
          dataGroup.y = _.filter(dataGroup.y, rating => {
            return !ratingFilter || _.includes(this.props.ratings, rating);
          });
          if (dataGroup.y.length < 1) {
            dataGroup.y = [0];
          }
          dataGroup.name = `${name} - ${month.start.format("MMMM YYYY")}`;
          dataGroup.marker.color = color;
          dataGroups.push(dataGroup);
        });
      } else {
        const dataGroup = _.cloneDeep(template);
        dataGroup.y = this.props.observations.map(observation => observation.debriefRate);
        dataGroup.y = _.filter(dataGroup.y, rating => {
          return !ratingFilter || _.includes(this.props.ratings, rating);
        });
        dataGroup.name = name;
        dataGroup.marker.color = color;
        dataGroups.push(dataGroup);
      }
    }

    const tables = [];
    const tableSize =
      dataGroups.length <= 6
        ? 6
        : months.length >= 8 ? 8 : months.length >= 5 ? months.length : months.length === 4 ? 8 : 6;

    for (let i = 0; i < dataGroups.length; i += tableSize) {
      const table = dataGroups.slice(i, i + tableSize);
      while (table.length < tableSize) {
        const dataGroup = _.cloneDeep(template);
        dataGroup.y = [0];
        dataGroup.name = " ".repeat(tableSize - table.length);
        table.push(dataGroup);
      }
      tables.push(table);
    }

    const layout = {
      title: "Domain Ratings",
      xaxis: {
        fixedrange: true,
      },
      yaxis: {
        fixedrange: true,
        autorange: false,
        range: [0.9, 5.1],
        showgrid: true,
        zeroline: true,
        dtick: 1,
        title: "Rating",
      },
      width: 1200,
      height: 700,
      showlegend: false,
      annotations: [
        {
          text: "Very Effective",
          x: -1.2,
          y: 5,
          showarrow: false,
        },
        {
          text: "Somewhat Effective",
          x: -1.2,
          y: 4,
          showarrow: false,
        },
        {
          text: "Neutral",
          x: -1.2,
          y: 3,
          showarrow: false,
        },
        {
          text: "Somewhat Ineffective",
          x: -1.2,
          y: 2,
          showarrow: false,
        },
        {
          text: "Very Ineffective",
          x: -1.2,
          y: 1,
          showarrow: false,
        },
      ],
    };

    const config = {
      displayModeBar: false,
    };

    return (
      <Wrapper>
        {tables.map((tableData, index) => (
          <PlotlyComponent key={index} className="whatever" data={tableData} layout={layout} config={config} />
        ))}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/plotly/ObservationRatings.jsx